import { useTheme } from 'next-themes';
import { Toaster as Sonner, ToasterProps as SonnerToasterProps } from 'sonner';

import { useMediaQuery } from 'hooks/useMediaQuery';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();
  const isMobile = useMediaQuery('(max-width: 768px)');

  // Responsive position: bottom-center on mobile (thumb-friendly), top-right on desktop
  const position: SonnerToasterProps['position'] = isMobile ? 'bottom-center' : 'top-right';

  return (
    // Accessibility: containerAriaLabel provides the aria-label for the toast container.
    // Sonner internally implements ARIA live regions with role="status" and aria-live="polite"
    // to ensure screen readers announce notifications after current speech completes.
    <Sonner
      containerAriaLabel="Notificacoes do sistema"
      theme={theme as ToasterProps['theme']}
      position={position}
      className="toaster group"
      // Limit simultaneous toasts to prevent visual clutter
      visibleToasts={3}
      // Gap between stacked toasts
      gap={8}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
